/**
 * Copies text to the clipboard.
 * Uses the modern Clipboard API with a fallback to execCommand for older browsers
 */
export default function copy(text: string): boolean {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text);
    return true;
  }

  // Fallback for older browsers
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    return document.execCommand('copy');
  } finally {
    document.body.removeChild(textarea);
  }
}
